const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: '交換を開始する前に、以下の手順が実行されていることを確認してください。',
    toDoListItems: [
      '交換するデバイスの接続を外す',
      '交換デバイスを接続する',
      '交換デバイスを設定する'
    ],
    install_replacement: {
      submitFirstStep: '詳細を見る',
      hems_device_api_fault:
        'アクティブなサードパーティのロードを交換しようとしているのに、ドロップダウンに表示されない場合は、ページをリロードしてください。',
      labelOldDevice: '旧デバイスの詳細',
      labelNewDevice: '新しいデバイスの詳細',
      submitSecondStep: '交換の確認',
      warningText: `デバイスの詳細が正しくない場合、またはその他の問題がある場合は、<a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >ここをクリック</a>して戻ってください。`,
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'エナジーメーター',
        SG_READY_GATEWAY: 'SGレディリレー',
        MICROINVERTER: 'Microinverter',
        AC_BATTERY: 'AC Battery',
        selectDeviceType: 'デバイスタイプを選択'
      }
    },
    replace_gateway: {
      submitFirstStep: 'IQ Energy Routerの交換',
      hems_device_api_fault:
        'アクティブなIQ Energy Routerを交換しようとしているのにドロップダウンメニューに表示されない場合は、ページをリロードしてください。',
      submitSecondStep: 'IQ Energy Routerの交換',
      labelOldDevice: '旧IQ ERの詳細',
      labelNewDevice: '新しいIQ ERの詳細を入力',
      warningText: `デバイスの詳細が正しくない場合、またはその他の問題がある場合は、<a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >ここをクリック</a>して戻ってください。`,
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Gatewayタイプを選択'
      }
    },
    alert: {
      footerMessage: '問題が解決しない場合は、Enphaseカスタマーサポートまでご連絡ください。',
      requestTimedOut: {
        mainMessage: 'リクエストがタイムアウトしました',
        subMessage: '後ほどもう一度お試しください'
      },
      multipleDeviceFound: {
        mainMessage: '交換はサポートされていません',
        subMessageIqErEvse:
          'サイトで2台以上のIQ ER EVSEが検出されました。このタイプのサイト構成では、交換はサポートできません。',
        subMessageEnergyMeter:
          'サイトで2台以上のエネルギーメーターが検出されました。このタイプのサイト構成では、交換はサポートできません。',
        subMessageSgReadyRelay:
          'サイトで2台以上のSGレディリレーが検出されました。このタイプのサイト構成では、交換はサポートできません。'
      },
      iqErOffline: {
        mainMessage: 'IQ ERはレポートしていません',
        subMessage: 'IQ Energy Routerの電源が入り、インターネットに接続されていることを確認してください'
      },
      deviceNotOffline: {
        mainMessage: '古いデバイスが接続されています',
        subMessage: '古いデバイスの接続が検出されました。古いデバイスを取り外し、交換を再度開始してください'
      },
      deviceReplacementInProgress: {
        mainMessage: 'このデバイスタイプでは、デバイス交換がすでに進行中です'
      },
      deviceNotFound: {
        mainMessage: '新しいデバイスが検出されません',
        subMessage:
          '新しいデバイスの詳細が見つかりません。新しいデバイスがインターネットに接続され、設定されていることを確認してください'
      },
      invalidRmaStatusId: {
        mainMessage: '交換に失敗しました ',
        subMessage: '交換状態が不明で交換に失敗しました'
      },
      activationDuplicateSite: {
        mainMessage: '交換に失敗しました',
        subMessage: '新しいIQ Energy Routerがすでにアクティブであるため、交換に失敗しました'
      },
      authPending: {
        mainMessage: '交換に失敗しました',
        subMessage: '既存のIQ Energy Routerがまだ認可されていないため、交換に失敗しました'
      },
      invalidIqEnergyRouter: {
        mainMessage: '交換に失敗しました',
        subMessage: '入力されたIQ Energy Routerのシリアル番号が有効でないため、交換に失敗しました'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: '交換に失敗しました',
        subMessage: '以前に検出されたHEMSサードパーティ製デバイスが見つからず、交換に失敗しました'
      },
      iqGatewayNotDiscovered: {
        mainMessage: '交換に失敗しました',
        subMessage: 'IQ GatewayがIQ Energy Routerによってまだ検出されていないため、交換に失敗しました'
      },
      authInitFailed: {
        mainMessage: '交換に失敗しました',
        subMessage: 'デバイスの認証が開始されず、交換に失敗しました'
      },
      invalidDeviceType: {
        mainMessage: 'デバイスタイプが交換に有効ではありません',
        subMessage: 'リクエストを送信する前に、正しいデバイスタイプが選択されていることを確認してください'
      },
      invalidSite: {
        mainMessage: 'サイトタイプがサポートされていません',
        subMessage: 'サイト構成がこの交換をサポートしていません'
      },
      invalidDevice: {
        mainMessage: '古いデバイスIDが無効のようです',
        subMessage: 'この交換はサポートされていません'
      },
      invalidDeviceUid: {
        mainMessage: '古いデバイスと新しいデバイスのIDが同じです',
        subMessage: 'この交換はサポートされていません'
      },
      deviceReplacementCompleted: {
        mainMessage: '交換が完了しました',
        subMessage:
          '新しいデバイスの機能検証が保留中の場合は、Enphase Installer Application (ITK)を使用して完了させてください。'
      },
      itkSuccessMessage: {
        iqErEvse: 'EVチャージャーが正常に交換されました',
        energyMeter: 'エネルギーメーターが正常に交換されました',
        sgReadyRelay: 'SGレディリレーが正常に交換されました',
        iqEnergyRouter: 'IQ Energy Routerが正常に交換されました'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'デバイスの詳細を取得しています' },
      initiatingReplacementLoader: { subMessage: '交換を開始しています' },
      replacementInprogressLoader: { subMessage: '交換の作業中です' }
    }
  }
};

export default DeviceReplacement;
